import { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import logo from "../assets/images/icomsys_logo.png";
import {useNavigate} from "react-router-dom";
import {CookiePolicy as cookiePolicy} from "../utils/cookiePolicy";
import alertUtils from "../utils/utils";
import {getGuid} from "../utils/deviceGuid";
// import {getTokenAsync} from "../utils/tokenManage";

function LoginPage() {
    const navigate = useNavigate();
    const [userId, setUserId] = useState("");
    const [userPw, setUserPw] = useState("");
    const [showPassword, setShowPassword] = useState(false); // 비밀번호 표시 토글 상태
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    // const [keepLogin, setKeepLogin] = useState(false);
    const [rememberId, setRememberId] = useState(false);

    useEffect(() => {
        const savedUserId = cookiePolicy.getCookie("rememberUserId");

        if (savedUserId) {
            setUserId(savedUserId);
            setRememberId(true);
        }

        /*const autoLogin = async () => {
            const keep = cookiePolicy.getCookie("keepLogin") === "Y";
            // const token = cookiePolicy.getCookie("accessToken");

            if (!keep || !token) return;

            try {
                await getTokenAsync();
                navigate("/history");
            } catch (e) {
                // cookiePolicy.removeCookie("accessToken");
                cookiePolicy.removeCookie("thisPage");
                cookiePolicy.removeCookie("keepLogin");
            }
        };

        autoLogin();*/
    }, [navigate]);

    const getEncryptKey = async () => {
        const res = await fetch(`${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/adm/encrypt/key`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });

        if (!res.ok) {
            throw new Error("암호화 키 조회 실패");
        }

        return await res.json();
    };

    const encodePassword = async (password) => {
        const data = await getEncryptKey();

        const cipher = CryptoJS.AES.encrypt(
            password,
            CryptoJS.enc.Hex.parse(data.key),
            {
                iv: CryptoJS.enc.Hex.parse(data.iv),
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC,
            }
        );

        return cipher.toString();
    };

    const loginCheck = async (e) => {
        e.preventDefault();

        const trimmedId = userId.trim();
        const trimmedPw = userPw.trim();

        if (!trimmedId) {
            setErrorMessage("아이디를 입력해 주세요.");
            return;
        }

        if (!trimmedPw) {
            setErrorMessage("비밀번호를 입력해 주세요.");
            return;
        }

        setIsLoading(true);
        setErrorMessage("");

        try {
            const encryptedPw = await encodePassword(trimmedPw);

            const requestBody = {
                userId: trimmedId,
                password: encryptedPw,
                userGuid: getGuid(),
            };

            const res = await fetch(`${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/adm/main/check`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify(requestBody),
            });

            if (res.status === 200) {
                const data = await res.json();
                const token = data.accessToken;

                // cookiePolicy.removeCookie("accessToken");
                cookiePolicy.removeCookie("thisPage");
                cookiePolicy.removeCookie("keepLogin");

                if (rememberId) {
                    cookiePolicy.setCookie("rememberUserId", trimmedId, 365);
                } else {
                    cookiePolicy.removeCookie("rememberUserId");
                }

                // if (keepLogin) {
                //     cookiePolicy.setCookie("keepLogin", "Y", 30);
                    cookiePolicy.setCookie("accessToken", token);
                //     cookiePolicy.setCookie("thisPage", "/view/main", 30);
                // } else {
                //     cookiePolicy.setCookie("accessToken", token);
                //     cookiePolicy.setCookie("thisPage", "/view/main");
                // }
                navigate("/history");
                return;
            }

            else if (res.status === 400) {
                setErrorMessage("계정이 잠겼습니다. 관리자에게 잠금해제 요청하세요.");
                return;
            }

            else if (res.status === 401) {
                const json = await res.json();

                if(json.errorCode === "AUTH_FAIL") {
                    const failCount = json.failCount || 0;
                    let msg = "아이디 또는 비밀번호가 올바르지 않습니다.";

                    if(failCount > 0){
                        msg += `(오류 횟수: ${failCount})`;
                    }

                    setErrorMessage(msg);
                    return;
                } else if(json.errorCode === "PWD_EXPIRED") {
                    alertUtils.confirm(
                        "비밀번호 변경후 90일이 지났습니다.\n 확인을 누르시면 변경페이지로 이동합니다.",
                        () => {
                            navigate("/passwordChange", {
                                state: { userId }
                            });
                        }
                    );
                } else {
                    setErrorMessage("인증에 실패했습니다.");
                    return;
                }
            }

            else if(res.status === 403){
                let msg = "";
                const json = await res.json();

                if(json.errorCode === "LOCKED_5_FAILS"){
                    msg = `비밀번호 5회 이상 오류로 계정이 잠겼습니다.\n관리자에게 문의하세요.`;
                }

                setErrorMessage(msg);
                return;
            }

            else if (res.status === 404) {
                let msg = "아이디 또는 비밀번호가 올바르지 않습니다.";

                try {
                    const json = await res.json();
                    if (json?.message && json.message !== "404Default") {
                        msg = `아이디 또는 비밀번호가 올바르지 않습니다. ${json.message}`;
                    }
                } catch (err) {
                    // ignore
                }

                setErrorMessage(msg);
                return;
            }

            else if (res.status === 423) {
                alertUtils.confirm(
                    "아이디가 사용중입니다. 확인을 누르시면 \n사용중인 사람이 로그아웃 됩니다.",
                    () => {
                        forceLogin();
                    }
                );
            }

            else {
                setErrorMessage("로그인 중 오류가 발생했습니다.");
            }
        } catch (err) {
            console.error(err);
            setErrorMessage("서버에 접속할 수 없습니다.");
        } finally {
            setIsLoading(false);
        }
    };

    const forceLogin = async () => {
        const trimmedPw = userPw.trim();
        try {
            const encryptedPw = await encodePassword(trimmedPw);

            const payload = {
                userId,
                password: encryptedPw,
                userGuid: getGuid()
            };

            const response = await fetch(
                `${(window.__env__?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL)}/api/v1/login/force`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    body: JSON.stringify(payload)
                }
            );

            if (!response.ok) {
                throw new Error("강제 로그인 실패");
            }
            const data = await response.json();
            const accessToken = data.accessToken;

            // cookiePolicy.removeCookie("accessToken");
            cookiePolicy.removeCookie("thisPage");
            cookiePolicy.removeCookie("keepLogin");

            if (rememberId) {
                cookiePolicy.setCookie("rememberUserId", userId, 365);
            } else {
                cookiePolicy.removeCookie("rememberUserId");
            }

            // if (keepLogin){
            //     cookiePolicy.setCookie("keepLogin", "Y", 30);
                cookiePolicy.setCookie("accessToken", accessToken);
            //     cookiePolicy.setCookie("thisPage", "/view/main", 30);
            // } else {
            //     cookiePolicy.setCookie("accessToken", accessToken);
            //     cookiePolicy.setCookie("thisPage", "/view/main");
            // }
            // navigate("/history");

            setTimeout(() => {
                navigate("/history");
            }, 500);
        } catch (error) {
            console.error("forceLogin error:", error);
        }
    };

    return (
        <div className="login-container">
            <div className="login-header">
                <div className="login-logo">
                    <img src={logo} alt="Logo" />
                </div>
            </div>

            <div className="login-card">
                <form onSubmit={loginCheck}>
                    <div className="login-field">
                        <label htmlFor="userId">User ID</label>
                        <input
                            type="text"
                            id="userId"
                            className="form-control"
                            placeholder="User ID"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                            autoComplete="username"
                        />
                    </div>

                    <div className="login-field">
                        <label htmlFor="userPw">Password</label>
                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                id="userPw"
                                className="form-control"
                                placeholder="Password"
                                value={userPw}
                                onChange={(e) => setUserPw(e.target.value)}
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className={`btn-toggle-pw ${showPassword ? "show" : ""}`}
                                onClick={() => setShowPassword((prev) => !prev)}
                                aria-label={showPassword ? "비밀번호 숨기기" : "비밀번호 표시"}
                            >
                            </button>
                        </div>
                    </div>

                    {errorMessage && <p className="error-text">{errorMessage}</p>}

                    <div className="check-group">
                        <label className="custom-check">
                            <input
                                className="remember-id"
                                type="checkbox"
                                checked={rememberId}
                                onChange={(e) => setRememberId(e.target.checked)}
                            />
                            <span className="checkmark"></span>
                            <span className="label-text">아이디 기억하기</span>
                        </label>

                        {/*<label className="custom-check">
                            <input
                                className="keep-login"
                                type="checkbox"
                                checked={keepLogin}
                                onChange={(e) => setKeepLogin(e.target.checked)}
                            />
                            <span className="checkmark"></span>
                            <span className="label-text">로그인 상태 유지</span>
                        </label>*/}
                    </div>

                        {rememberId && (
                            <p className="login-guide">
                                정보 보호를 위해 반드시 개인 기기에서 사용해주세요!
                            </p>
                        )}

                        <button type="submit" className="btn btn-login" disabled={isLoading}>
                            {isLoading ? "로그인 중..." : "로그인"}
                        </button>
                </form>
            </div>

            <div className="copyright">&copy; Copyright 2025. All rights reserved.</div>
        </div>
    );
}

export default LoginPage;